import { Box, Typography, Button, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { StandardDialog } from "@roc/ui"
import { sanitizeHtml } from '@roc/ui/utils';
import { observer } from "mobx-react"
import "../styles/mobileDialogStyle.css"
import { useCallback, useEffect, useState } from "react";

const useStyles = makeStyles(theme => ({
  mobileContainer: {
    '& .cs-button': {
      color: theme.palette.primary.dark + ' !important',
    },
    '& .cs-typing-indicator__dot': {
      backgroundColor: theme.palette.primary.dark + ' !important',
    },
    '& .cs-typing-indicator__text': {
      color: theme.palette.primary.dark + ' !important',
    },
    [theme.breakpoints.down(769)]: {
      '& .cs-sidebar.cs-sidebar--left': {
        flexGrow: 1,
        maxWidth: '100%',
        overflow: 'auto',
      },
      '& .cs-conversation__content': {
        display: 'block !important',
      },
    },
  },
  grayedOut: {
    opacity: 0.5,
    border: '10px',
    backgroundColor: '#F2F2F2',
    borderColor: '#000000',
  }
}));

const DialogContent = observer(({ rephrasedComponent, initialMessage, isTabletSize }) => {
  const classes = useStyles();

  const sendOriginal = useCallback(() => {
    rephrasedComponent.props.setCheckGPT(false);
    rephrasedComponent.props.setMessage(initialMessage);
    rephrasedComponent.props.handleSendMessageRef.current?.();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: { ctrlKey: any; key: string; preventDefault: () => void; }) => {
      if (event.ctrlKey) {
        if (event.key === 'o' || event.key === 'O') {
          event.preventDefault();
          sendOriginal()
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [sendOriginal]);

  return (
    <Box mb={2} display={'flex'} flexDirection={'column'} flexGrow={1}>
      <Box>
        <Box
          style={{ display: 'flex', justifyContent: 'space-between' }}
          justifyContent="space-between"
          alignItems="flex-start"
          p={1}
        >
          <Typography variant="h6"
          >
            ORIGINAL
          </Typography>
        </Box>
        <Box
          style={{ display: 'flex', justifyContent: 'space-between' }}
          justifyContent="space-between"
          alignItems="flex-end"
          p={1}
        >
          <p style={{ whiteSpace: 'nowrap', fontSize: '.70em' }} ><b>CTRL + O </b> TO SEND ORIGINAL MESSAGE</p>
        </Box>
        <Box my={1} maxHeight={300} overflow={'auto'} border={'2px solid #ccc'} padding={2} className={classes.grayedOut}>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(initialMessage) }} />
        </Box>
      </Box>
      <Box mb={2}>
        <Box
          style={{ display: 'flex', justifyContent: 'space-between' }}
          justifyContent="space-between"
          alignItems="flex-start"
          p={1}
        >
          <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
            <Typography variant="h6" color='primary'>
              REPHRASED
            </Typography>
          </div>
        </Box>
        <Box className={isTabletSize ? classes.mobileContainer : ""} my={1} border={'1px solid #bbb'}>
          {
            rephrasedComponent
          }
        </Box>
      </Box>
    </Box>
  )
})

const useDialogContentStyles = makeStyles(theme => ({
  root: {
    'overflowY!': 'auto',
  },
}));


export const GPTMessageCorrectionDialog = observer(({
  open,
  onClose,
  rephrasedComponent,
  initialMessage,
  isTabletSize,
}) => {
  const dialogContentclasses = useDialogContentStyles();
  return (
    <StandardDialog
      open={open}
      rephraseClass={true}
      title={'LoanChat.ai 🪄'}
      onClose={onClose}
      handleClose={onClose}
      maxWidth={'lg'}
      overflowDialog={false}
      dialogContentclasses={dialogContentclasses}
      dialogContent={<DialogContent rephrasedComponent={rephrasedComponent} initialMessage={initialMessage} isTabletSize={isTabletSize} />}
      removeContentBox
    />
  )
})